import React from 'react';
import Select from "./Select";

const SelectComponent = ({ options, value, onChange, placeholder, isRequired, validation, isDisabled, columnClass }) => {
  const selectedValue = value ? options.find((option) => option.value === value) : null;
console.log(selectedValue);
  return (
    <div className={`bootstrap-select-wrapper ${columnClass}`}>
      <Select
        clearText="Annulla"
        defaultMenuIsOpen={false}
        icon={false}
        onChange={onChange}
        options={options}
        isSearchable
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        value={selectedValue}
        placeholder={placeholder}
        aria-required={isRequired}
        isDisabled={isDisabled}
      />
      {validation && isRequired && !value && (
        <small id="errorSelect" className="form-text text-danger">
          Il campo non può essere vuoto!
        </small>
      )}
    </div>
  );
};

export default SelectComponent;